import { loginAmplifyConverter } from 'data/converters';
import {
  TAmplifyLoginData,
  TAmplifyLoginDataUi,
  TLoginDataUi,
  TLoginData,
} from 'data/types';
import { loginAmplifyService } from 'api/services/authServices';
import useApiResult from './useApiResult';

export const useLogin = (
  onSuccess?: (data: TAmplifyLoginDataUi) => void,
  onFail?: (err: Error) => void,
) => {
  return useApiResult<
    TLoginDataUi,
    TLoginData,
    TAmplifyLoginDataUi,
    TAmplifyLoginData
  >(loginAmplifyService, loginAmplifyConverter, onSuccess, onFail);
};